import { defineNuxtRouteMiddleware, setPageLayout } from "#imports";
import { kebabCase } from "change-case";
export default defineNuxtRouteMiddleware((to) => {
  if (!to.query.layout)
    return;
  const layout = kebabCase(to.query.layout);
  setPageLayout(layout);
});
